import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  CasePaymentRefund,
  PaymentPayload,
  PaymentRequestResponse,
  PaymentTransactionResult
} from "@vp/models";
import { API_BASE_URL } from "@vp/shared/tokens";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class CybersourceService {
  private apiBaseUrl = inject(API_BASE_URL);
  private http = inject(HttpClient);

  getTransientToken() {
    const apiURL = `${this.apiBaseUrl}/cybersource/tokenKey`;
    return this.http.get(apiURL);
  }

  getclientLibrary(clientLibrary: string) {
    const apiURL = `${this.apiBaseUrl}/cybersource/clientLibrary/${clientLibrary}`;
    return this.http.get(apiURL);
  }

  submitPayment(caseId: string, paymentPayload: PaymentPayload, submitCaseOnSuccess = false) {
    const apiURL = `${this.apiBaseUrl}/cybersource/${caseId}/payment`;
    let params = new HttpParams();

    if (submitCaseOnSuccess) {
      params = params.set("submitCaseOnSuccess", submitCaseOnSuccess);
    }

    return this.http
      .post(apiURL, paymentPayload, { params })
      .pipe(map((response: any) => this.mapTransactionResult(response)));
  }

  refundPayment(paymentRefund: CasePaymentRefund, transactionId: string) {
    const apiURL = `${this.apiBaseUrl}/cybersource/payment/refund?transactionId=${transactionId}`;
    return this.http.post(apiURL, paymentRefund);
  }

  private mapTransactionResult(response: PaymentRequestResponse) {
    return {
      status: response.paymentMade ? "success" : "failed",
      message: response.message,
      record: {
        transactionId: response.transactionId
      }
    } as PaymentTransactionResult;
  }
}
